// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Spw8","error":"styles_error__LZ-Ix","success":"styles_success__2hfed"};